export default __webpack_public_path__ + "static/media/Home-Banner.63aa2ff5.jpg";